(() => {
  "use strict";

  const OFFER_SELECTOR = "[data-nuero-discount-offer]";
  const STORAGE_PREFIX = "nuero_discount_offer_";

  async function applyDiscountSession(code) {
    const currentPath =
      window.location.pathname +
      window.location.search +
      window.location.hash;

    const discountUrl =
      `/discount/${encodeURIComponent(code)}` +
      `?redirect=${encodeURIComponent(currentPath)}`;

    const response = await fetch(discountUrl, {
      method: "GET",
      credentials: "same-origin",
      redirect: "follow",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error(`Discount request failed: ${response.status}`);
    }
  }

  function initializeOffer(root) {
    if (!root || root.dataset.nueroInitialized === "true") return;

    root.dataset.nueroInitialized = "true";

    const checkbox = root.querySelector(
      "[data-nuero-discount-checkbox]"
    );

    const copyButton = root.querySelector(
      "[data-nuero-copy-code]"
    );

    const checkoutNote = root.querySelector(
      "[data-nuero-checkout-note]"
    );

    if (!checkbox || !copyButton || !checkoutNote) return;

    const code = root.dataset.discountCode;
    const productId = root.dataset.productId;
    const storageKey = `${STORAGE_PREFIX}${productId}`;

    let applyingDiscount = false;

    async function activateOffer() {
      checkoutNote.hidden = false;
      localStorage.setItem(storageKey, "active");

      if (applyingDiscount) return;

      applyingDiscount = true;

      try {
        await applyDiscountSession(code);
      } catch (error) {
        console.error(
          "Nuero discount could not be automatically applied.",
          error
        );
      } finally {
        applyingDiscount = false;
      }
    }

    function deactivateOffer() {
      checkoutNote.hidden = true;
      localStorage.removeItem(storageKey);
    }

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        activateOffer();
      } else {
        deactivateOffer();
      }
    });

    copyButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const previousText = copyButton.textContent;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const temporaryInput = document.createElement("input");

        temporaryInput.value = code;
        temporaryInput.setAttribute("readonly", "");
        temporaryInput.style.position = "fixed";
        temporaryInput.style.opacity = "0";

        document.body.appendChild(temporaryInput);
        temporaryInput.select();
        document.execCommand("copy");
        temporaryInput.remove();
      }

      copyButton.textContent = "Copied ✓";

      window.setTimeout(() => {
        copyButton.textContent = previousText;
      }, 1500);
    });

    if (localStorage.getItem(storageKey) === "active") {
      checkbox.checked = true;
      checkoutNote.hidden = false;
    }
  }

  function initializeAllOffers(container = document) {
    container
      .querySelectorAll(OFFER_SELECTOR)
      .forEach(initializeOffer);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initializeAllOffers();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllOffers(event.target);
  });
})();